import { render, staticRenderFns } from "./EditISPProvider.vue?vue&type=template&id=620bcdf6&"
import script from "./EditISPProvider.vue?vue&type=script&lang=js&"
export * from "./EditISPProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports